import React from 'react';
import MainLayout from '@/components/layout/MainLayout';
import ProjectDetail from '@/components/projects/ProjectDetail';

const ProjectDetailPage = () => {
  return (
    <MainLayout>
      <ProjectDetail />
    </MainLayout>
  );
};

export default ProjectDetailPage;
